export enum TokenTypeEnum {
  M2M = "m2m_token",
  U2M = "u2m_token",
}
